













import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputEmail'
})
export default class InputEmail extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate

  get regrasValidacaoEmail() {
    const regras = this.regrasValidacao
    regras.push((v: string) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail inválido')
    return regras
  }
}
